/* Dialog Text */
import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";

export interface EditUnpaidOrderDialogData {
  dialogTitle: string;
  isNew: boolean;
  subscriptionName: string;
  orderTotal: number;
  previouslyPaid: number;
  totalDue: number;
  amountPaid: number;
  paymentDate: Date;
}

@Component({
  selector: "edit-unpaid-order-dialog",
  styleUrls: ["edit-unpaid-order-dialog.component.css"],
  templateUrl: "./edit-unpaid-order-dialog.component.html",
})
export class EditUnpaidOrderDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditUnpaidOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditUnpaidOrderDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }
}

/* Calling Methods */
/*
  callEditUnpaidOrder(params: EditUnpaidOrderDialogData) {
    var dialogRef = this.dialog.open(EditUnpaidOrderDialogComponent, {
      width: '500px',
      data: params
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result != null && result.ResultType != null && result.ResultType == DialogResultType.Ok) {
        //Do something here!
      }
    });
  }
*/
